import axios from "axios";
import api from "../../admin_module/services/admin_api_global";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchPublicFreeBundles = () =>
  axios.get(`${BASE_URL}/public/free-bundle`).then((r) => r.data);

export const fetchAdminFreeBundles = () =>
  api.get("/admin/free-bundle").then((r) => r.data);

export const updateFreeBundleById = (id, payload) =>
  api.put(`/admin/free-bundle/${id}`, payload).then((r) => r.data);
